// import React from 'react';
// import ReactDOM from 'react-dom';
// import '../Modal/modal.css';
// import Modal from '@mui/material/Modal';
// import Box from '@mui/material/Box';
// import ShowDataTable from '../Tables/ShowDataTable';
// import { useTranslation } from 'react-i18next';
// import { t } from 'i18next';

// import Row from 'react-bootstrap/Row';
// import Col from 'react-bootstrap/Col';
// import Container from 'react-bootstrap/Container';
// import Button from 'react-bootstrap/Button';


// const ShowResolverInfoModal = ({ open, handleClose, handleUserList }) => open ?
//     (
//         <>

//             {/* <div className="modal-overlay" /> */}
//             {/* <div className="modal-wrapper" aria-modal aria-hidden role="dialog"> */}
//             {/* <ModalBody open={isShowing} handleClose={hide}></ModalBody> */}
//             {/* <Modal open={isShowing} onClose={hide}>
//                     <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', border: '2px solid #000', p: 2 }}>
//                         <div className="modal-header">
//                             <h2>{t('general.lable.userList.text')}</h2>
//                             <button onClick={hide}>&times;</button>
//                         </div>
//                         <div className="modal-body">
//                             <ShowDataTable columns={['USER LIST']} rows={handleUserList}></ShowDataTable>
//                         </div>
//                         <div className="modal-footer">
//                             <button onClick={hide}>{t("general.button.panel.footer.close")}</button>
//                         </div>
//                     </Box>
//                 </Modal> */}
//             {/* </div> */}
//             const rowsData=[];
//             console.log(handleUserList)
//             <Container fluid>
//                 <Row>
//                     <Box>
//                         <Box>
//                             <Col lg={12} className="text-end">
//                                 <ShowDataTable columns={[t("general.label.user.list")]} rows={handleUserList}></ShowDataTable>
//                             </Col>
//                         </Box>
//                         <Box mt={1} display="flex" justifyContent="flex-end">
//                             <Col lg={12} className="text-end">
//                                 <Button variant="primary" onClick={handleClose}>
//                                     {t("general.button.panel.footer.close")}
//                                 </Button>
//                             </Col>
//                         </Box>
//                     </Box>
//                 </Row>
//             </Container>
//         </>
//     ) : null;

// export default ShowResolverInfoModal;





import React,{ useState, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ShowDataTable from '../Tables/ShowDataTable';
import { t } from 'i18next';
import DatatTable from '../TableNoStyle';

const ShowResolverInfoModal = ({ open, handleClose, handleUserList }) => {

    const columnData = useMemo(
        () => [
          {
            accessorKey: 'name',
            header: t("general.label.user.list"),
            size: 30,
          },
        ],
        [t],
      );
    
    
      const rowsData = [];
    
      handleUserList && handleUserList.forEach((item, index) => {
        rowsData.push({
          name: item.firstName+" "+item.lastName,
        });
      });
     
    console.log(handleUserList); 

    return open ? (
        <Container fluid>
            <Row>
                <Box>
                    <Box>
                        <Col lg={12} className="text-end">
                            <DatatTable tableData={{ columnData: columnData, rowsData: rowsData }}></DatatTable>
                        </Col>
                    </Box>
                    <Box mt={1} display="flex" justifyContent="flex-end">
                        <Col lg={12} className="text-end">
                            <Button variant="primary" onClick={handleClose}>
                                {t("general.button.panel.footer.close")}
                            </Button>
                        </Col>
                    </Box>
                </Box>
            </Row>
        </Container>
    ) : null;
}

export default ShowResolverInfoModal;
